<div class="document-option-wrapper">
	<button mat-icon-button [matMenuTriggerFor]="menu">
		<mat-icon>more_horiz</mat-icon>
	</button>
	<mat-menu #menu="matMenu">
		<!-- Future functionality -->
		<!-- <button mat-menu-item>
        <mat-icon>remove_red_eye</mat-icon>
        <span>Preview</span>
      </button> -->
		<button
			mat-menu-item
			id="file-download"
			(click)="download(document?.body, document?.metadata?.filename, document?.metadata?.extension)">
			<mat-icon>archive</mat-icon>
			<span>Download</span>
		</button>
		<button mat-menu-item id="file-delete" (click)="deleteConfirmation(document?.key)">
			<mat-icon>delete_outline</mat-icon>
			<span>Delete</span>
		</button>
	</mat-menu>
</div>
